export default {
	PickColor: 'Choisir une couleur',
	Close: 'Fermer',
};
